module.exports = __webpack_public_path__ + "media/Images/employer-home-hero-2-eb1709a0b41174a12f05425555e04539.jpg";